const ApiKeys = {
    FirebaseConfig: {
        apiKey: "AIzaSyCyH2f_y7H_3d9NX-sTquDOn8kxKnYp2pc",
        authDomain: "aestradalegal.firebaseapp.com",
        databaseURL: "https://aestradalegal-default-rtdb.firebaseio.com",
        projectId: "aestradalegal",
        storageBucket: "aestradalegal.appspot.com",
        messagingSenderId: "639017185739",
        appId: "1:639017185739:web:417f5c8d569c00b46ac64e",
        measurementId: "G-H2PF4GVXYJ"
    }
}

export default ApiKeys;